<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="info-box">
        <div
          class="avatar"
          :style="{
            backgroundImage: 'url(' + $store.state.imgUrl + info.avatar + ')'
          }"></div>
        <div class="name up">{{ info.name }}</div>
        <div class="contact">{{ info.email }}</div>
        <div class="mcn up">{{ info.mcn_name }}</div>
        <div class="des">
          <span v-if="!showMore">{{
            info.profile && info.profile.length > 100
              ? info.profile.slice(0, 100) + '...'
              : info.profile
          }}</span>
          <span v-else>{{ info.profile }}</span>
          <span
            class="show-more"
            @click="handleMore"
            v-if="
              info.profile && info.profile.length > 100 && !showMore
            "></span>
          <span
            class="show-more up"
            @click="handleMore"
            v-if="info.profile && info.profile.length > 100 && showMore"></span>
        </div>
      </div>
      <div class="icon-block">
        <div class="icon photo" v-if="info.ins">
          <a :href="info.ins" target="_blank"></a>
        </div>
        <div class="icon facebook" v-if="info.facebook">
          <a :href="info.facebook" target="_blank"></a>
        </div>
        <div class="icon twitter" v-if="info.twitter">
          <a :href="info.twitter" target="_blank"></a>
        </div>
      </div>
      <div class="list-title2">{{ $t('mynfts') }}</div>
      <div class="list2">
        <div class="item" v-for="(item, index) in nftList" :key="index">
          <div
            class="img-box"
            :style="{
              backgroundImage: 'url(' + $store.state.imgUrl + item.image + ')'
            }"></div>
          <div class="num icon">{{ item.price }}</div>
          <div class="price up">
            {{ item.sold }} <span class="unit special">{{ $t('sold') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postMcnBabeInfo, postMcnBabeNftList } from '@/api/mcn'

export default {
  name: 'McnBDetail',
  components: {},
  data() {
    return {
      nftList: [],
      info: {},
      showMore: false
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let params = {
        babe_user_id: this.$route.query.babe_user_id
      }
      postMcnBabeInfo(params).then((res) => {
        this.info = res.data
      })
      postMcnBabeNftList(params).then((res) => {
        this.nftList = res.data
      })
    },
    handleMore() {
      this.showMore = !this.showMore
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mcn/bdetail.vue